import * as React from "react";
import Recaptcha from "react-recaptcha";
import { Loading } from "src/components/ui";
import FormButton from "@src/components/ui/FormButton";
import FormInput from "@src/components/ui/FormInput";
import FormCheckBox from "@src/components/ui/FormCheckBox";
import Message from "@src/components/frontend/Message";
import { api, shared } from "@src/services/api";
import { route } from "src/services/browser";
import { notify } from "@src/services/notify";

interface Props {

}

interface State {
    loading: boolean,
    thanks: boolean,
    _registrazione_email?: string,
    _registrazione_password?: string,
    _registrazione_repassword?: string,
    _registrazione_recaptcha?: string,
    _registrazione_termini?: boolean,
    _registrazione_newsletter?: boolean
}

export default class Registrazione extends React.Component<Props, State> {
    state = {
        loading: false,
        thanks: false,
        remailSent: false,
        _registrazione_recaptcha: false,
    } as State;

    showThanks() {
        this.setState(
            {thanks: true}
        );
    }

    handleChange(field, value) {
        this.setState({
            [field]: value
        });
    }

    resendEmail() {
        this.setState({
            remailSent: false
        });
        const { ...customer } = this.state;

        api({
            method: "POST",
            url: "send-activation",
            data: {
                email: customer._registrazione_email,
            }
        }).then((response) => {
            console.log('response', response);

            setTimeout(() => {
                this.setState({
                    remailSent: true
                });
            }, 2000);
        });
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    submit() {
        const { ...customer } = this.state;

        if( ! this.validateEmail(customer._registrazione_email) ) {
            alert('Formato email inserito non valido.');
            return;
        }


        if( customer._registrazione_password === undefined || customer._registrazione_password === '' || ! customer.hasOwnProperty('_registrazione_password') ) {
            alert('Inserire correttamente la password.');
            return;
        }
        if( customer._registrazione_repassword === undefined || customer._registrazione_repassword === '' || ! customer.hasOwnProperty('_registrazione_repassword') ) {
            alert('Inserire correttamente la conferma password.');
            return;
        }

        if(customer._registrazione_password != customer._registrazione_repassword) {
            alert('Le password inserite non coincidono.');
            return;
        }

        if(customer._registrazione_termini === undefined || customer._registrazione_termini === false) {
            alert('Accettare i termini di utilizzo della piattaforma.');
            return;
        }

        if(! customer._registrazione_recaptcha) {
            alert('Verificare prima la propria identità.');
            return;
        }

        if(! customer.hasOwnProperty('_registrazione_newsletter')) {
            customer._registrazione_newsletter = false;
        }

        api( {
            method: "POST",
            url: "register",
            contentType: 'application/json',
            data: customer,
            appActions: true
        }).then((response) => {
            console.log('response', response);

            if(response.hasOwnProperty('email')) {
                notify( { text: 'Registrazione effettuata correttamente', type: 'SUCCESS' } );
                this.showThanks();
            } else {
                notify( { text: 'Email già in uso.', type: 'ERROR' } );
            }

        }).catch((response) => {
            // prevent error in console
            notify( { text: 'Email già in uso.', type: 'ERROR' } );
            // notify( { text: response.message, type: 'ERROR' } );
        });
    }

    onRecaptchaLoad(response) {
        console.log('onRecaptchaLoad response:', response);
    }

    onRecaptchaVerify(response) {
        console.log('onRecaptchaVerify response:', response);
        this.setState({
            _registrazione_recaptcha: true,
        })
    }

    onRecaptchaExpired(response) {
        console.log('onRecaptchaExpired response:', response);
        document.location.reload();
    }

    container() {
        return (
            <section className="container">
                <div id="fullCarousel" className="carousel slide fullpage" data-ride="carousel">

                <div className="carousel-inner">
                    <div className="item active">
                        <img src="/static/pages/auth/sfondo.jpg" alt="img 3" />
                        <div className="top_text hidden-xs hidden-sm hidden-md">
                            {/*<h3 className="white_text">Schoolvisor<sup>&reg;</sup></h3>*/}
                        </div>
                        <div className="bottom_text hidden-xs hidden-sm hidden-md">
                            <h3>Schoolvisor.<br /> Il tuo compagno di scuola.</h3>
                            <p>
                                La scelta di una scuola è un momento importante.<br />
                                Aiutaci a renderlo un “compito” più facile:<br />
                                registrati e condividi la tua esperienza, recensendo la tua scuola.
                            </p>
                            <p>
                                Gestisci una scuola?<br />
                                Prenditi cure della tua scuola: aggiorna le tue informazioni e gestisci le recensioni.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-5 col-lg-offset-0">
                        <section className="boxed register-form">
                            <div role="form" method="POST" action="">
                                <header>
                                    <p>
                                        Crea un account
                                    </p>
                                    <h3>
                                        Schoolvisor
                                    </h3>

                                </header>

                                <article>
                                    <hr className="hr-text margin-hr-con" data-content="Continua con" />
                                    <p className="margin-social">
                                        <a href={route('social.facebook')}
                                           className="btn main auth-facebook"><img src="/static/icons/facebook-f.png" /><span>Accedi con Facebook</span></a>
                                        <a href={route('social.google')}
                                           className="btn main auth-google"><img src="/static/icons/google.png" /><span style={{ height: '33px' }}>Accedi con Google</span></a>
                                    </p>
                                    <div className="first_text">Registrarsi con un account social è molto meglio.</div>
                                    <div className="second_text">Nessuna password da ricordare.</div>
                                    <hr className="hr-text margin-hr-or" data-content="oppure" />
                                </article>
                                <article style={{marginTop: "-20px"}}>
                                    <div className="field list">
                                        <FormInput type={"email"} className="custom-email-input" placeholder={"email"} icon={"icon-email"} name="_registrazione_email" onChange={this.handleChange.bind(this)} />
                                        <FormInput type={"password"} placeholder={"password"} icon={"icon-password"} name="_registrazione_password" onChange={this.handleChange.bind(this)} />
                                        <FormInput type={"password"} placeholder={"conferma password"} icon={"icon-password"} name="_registrazione_repassword" onChange={this.handleChange.bind(this)} />

                                        <div className="margin"></div>

                                        <div style={{marginTop: "25px", position: 'relative', height: '30px'}}>
                                            {/*<FormCheckBox size={"13px"} required={true} name="_registrazione_termini" onChange={this.handleChange.bind(this)}>Accetto i <span onClick={() => { const el = document.getElementById('toc'); this.simulateClick(el); }} className="underline">termini di utilizzo</span> del portale e la <span className="underline">normativa privacy</span></FormCheckBox>*/}
                                            <FormCheckBox size={"13px"} required={false} name="_registrazione_termini" onChange={this.handleChange.bind(this)}></FormCheckBox>
                                            <label className="custom-checkbox-label" style={ { fontSize: '13px' } } > Accetto i <span onClick={() => { const el = document.getElementById('toc'); this.simulateClick(el); }} className="underline">termini di utilizzo</span> del portale e la <span onClick={() => { const el = document.getElementById('privacy-policy'); this.simulateClick(el); }} className="underline">normativa privacy</span> </label>
                                        </div>
                                        {/*
                                        <div style={{marginTop: "25px", marginBottom: "25px", position: 'relative', height: '30px'}}>
                                            <FormCheckBox size={"13px"} name="_registrazione_newsletter" onChange={this.handleChange.bind(this)}> </FormCheckBox>
                                            <label className="custom-checkbox-label" style={ { fontSize: '13px' } } > Voglio essere informato sulle novità di Schoolvisor&reg; </label>
                                        </div>
                                        */}

                                        <div className="margin" style={{ marginTop: "50px" }}></div>

                                        <div className="margin cione" style={{ position: "relative", margin: 'auto', width: '80%' }}>
                                            <Recaptcha
                                                sitekey={shared.app.nocaptcha_key}
                                                render="explicit"
                                                onloadCallback={this.onRecaptchaLoad.bind(this)}
                                                verifyCallback={this.onRecaptchaVerify.bind(this)}
                                                expiredCallback={this.onRecaptchaExpired.bind(this)}
                                            />
                                        </div>

                                        <div className="margin" style={{ marginTop: "50px" }}></div>

                                        <FormButton type="submit" text="Registrati" onClick={() => this.submit()} style={ {color: '#FFFFFF !important'} } ></FormButton>
                                    </div>
                                </article>
                            </div>
                        </section>
                    </div>
                    <div className="col-md-2 col-lg-7">

                    </div>
                </div>
            </section>
        );
    }

    /**
     * Simulate a click event.
     * @public
     * @param {Element} elem  the element to simulate a click on
     */
    simulateClick(elem) {
        // Create our event (with options)
        var evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
        // If cancelled, don't dispatch our event
        var canceled = !elem.dispatchEvent(evt);
    };

    render() {
        const { loading, thanks } = this.state;

        if (loading) return <Loading />;

        return (
            <div className="frontend_Registrazione">
                {thanks ?
                    <Message action={"Inviami di nuovo la mail"} title={"Grazie, adesso fai parte della nostra famiglia!"} image={"/static/img/thanks.png"}
                             post={this.state.remailSent ? "Abbiamo provveduto ad inviarti un'altra mail." : "Se non hai ricevuto la email, te ne inviamo un'altra!"}
                             actionicon={"icon-email"}
                             description={"Controlla la tua casella email.<br />Segui le indicazioni per attivare il tuo profilo e finalizzare la registrazione"}
                             onClick={() => this.resendEmail()}></Message> :
                    this.container()
                }

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/frontend/Registrazione.tsx